import { createTheme } from "@mui/material"

const theme = createTheme({
    palette: {
        primary: {
            main: '#009188',
            dark: '#004846'
        },
    },
    typography: {
        button: {
            textTransform: 'none'
        }
    }
})
export default theme